/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Review_Prompt_TitleInputs */

const en_mobile_review_prompt_title = /** @type {(inputs: Mobile_Review_Prompt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enjoying Listening?`)
};

const es_mobile_review_prompt_title = /** @type {(inputs: Mobile_Review_Prompt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Estás disfrutando Listening?`)
};

/**
* | output |
* | --- |
* | "Enjoying Listening?" |
*
* @param {Mobile_Review_Prompt_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_review_prompt_title = /** @type {((inputs?: Mobile_Review_Prompt_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Review_Prompt_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_review_prompt_title(inputs)
	return en_mobile_review_prompt_title(inputs)
});